ch-action-group-render {
  display: contents;
}